"use client";

import { motion } from "framer-motion";
import { ParallaxLayer } from "./ParallaxLayer";

interface FloatingShape {
    size: number;
    x: string;
    y: string;
    delay: number;
    duration: number;
    color: string;
    blur: number;
    parallaxSpeed: number;
}

const SHAPES: FloatingShape[] = [
    { size: 300, x: "10%", y: "15%", delay: 0, duration: 20, color: "rgba(59,130,246,0.06)", blur: 60, parallaxSpeed: 0.1 },
    { size: 200, x: "75%", y: "10%", delay: 2, duration: 25, color: "rgba(168,85,247,0.05)", blur: 50, parallaxSpeed: -0.15 },
    { size: 250, x: "60%", y: "60%", delay: 4, duration: 22, color: "rgba(6,182,212,0.05)", blur: 55, parallaxSpeed: 0.2 },
    { size: 180, x: "20%", y: "70%", delay: 1, duration: 18, color: "rgba(99,102,241,0.04)", blur: 45, parallaxSpeed: -0.1 },
    { size: 150, x: "85%", y: "45%", delay: 3, duration: 23, color: "rgba(16,185,129,0.04)", blur: 40, parallaxSpeed: 0.12 },
    { size: 120, x: "40%", y: "30%", delay: 5, duration: 28, color: "rgba(236,72,153,0.03)", blur: 35, parallaxSpeed: -0.08 },
];

export function FloatingElements({ className }: { className?: string }) {
    return (
        <div
            className={`pointer-events-none absolute inset-0 overflow-hidden ${className || ""}`}
            aria-hidden="true"
        >
            {SHAPES.map((shape, i) => (
                <ParallaxLayer key={i} speed={shape.parallaxSpeed}>
                    <motion.div
                        className="absolute rounded-full"
                        style={{
                            width: shape.size,
                            height: shape.size,
                            left: shape.x,
                            top: shape.y,
                            background: `radial-gradient(circle, ${shape.color} 0%, transparent 70%)`,
                            filter: `blur(${shape.blur}px)`,
                        }}
                        animate={{
                            y: [0, -30, 0, 20, 0],
                            x: [0, 15, 0, -10, 0],
                            scale: [1, 1.05, 1, 0.98, 1],
                        }}
                        transition={{
                            duration: shape.duration,
                            delay: shape.delay,
                            repeat: Infinity,
                            ease: "easeInOut",
                        }}
                    />
                </ParallaxLayer>
            ))}
        </div>
    );
}
